import React from "react"

export default function GooglePlus(props) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 455.7 455.7"
      {...props}
    >
      <path
        fill="#dd4b39"
        d="M0 0v455.7h455.7V0H0zm265.7 247c-7.8 51.2-46 80.6-95.4 80.6a100.6 100.6 0 010-201.1c26.9 0 50.4 9.6 67.5 26.2L209 181.6a53 53 0 00-38.7-15.1A60.4 60.4 0 00111 227a59.7 59.7 0 0059.2 59.8c27.4 0 48.1-13.2 54.1-39.8h-54.1v-40.3h95.1a132.7 132.7 0 01.2 40.4zm120.7-12.5h-35.2v35.2h-25v-35.2h-35.3v-25h35.3v-35.3h25v35.3h35.2v25z"
      />
    </svg>
  )
}
